var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "base-data-item",
      class:
        _vm.resetDateObj.increaseNum < 0
          ? "base-data-item-redbg"
          : "base-data-item-greenbg",
    },
    [
      _c("div", { staticClass: "title" }, [
        _c(
          "label",
          [
            _vm._v(_vm._s(_vm.resetDateObj.title) + " "),
            _vm.resetDateObj.tip
              ? _c(
                  "el-tooltip",
                  {
                    staticClass: "item",
                    attrs: {
                      effect: "dark",
                      content: _vm.resetDateObj.tip,
                      placement: "top",
                    },
                  },
                  [_c("i", { staticClass: "el-icon-question" })]
                )
              : _vm._e(),
          ],
          1
        ),
        _c("span", [_vm._v("数据时间：" + _vm._s(_vm.resetDateObj.dateStr))]),
      ]),
      _c("p", {
        staticClass: "total-number",
        domProps: { innerHTML: _vm._s(_vm.resetDateObj.totalNumber) },
      }),
      _c(
        "div",
        { staticClass: "compare" },
        [
          _c(
            "p",
            {
              class:
                _vm.resetDateObj.increaseNum < 0 ? "data-red" : "data-green",
            },
            [
              _c("span", {
                staticClass: "arrow south-east el-icon-bottom-right",
              }),
              _c("span", { staticClass: "arrow north-east el-icon-top-right" }),
              _c("label", [_vm._v("环比增长")]),
              _vm.resetDateObj.increaseNum >= 0
                ? _c("span", [_vm._v("+")])
                : _vm._e(),
              _vm._v(_vm._s(_vm.resetDateObj.increase) + "% "),
            ]
          ),
          _vm.resetDateObj.prevMonthIncrease
            ? [
                _c(
                  "p",
                  {
                    class:
                      _vm.resetDateObj.prevMonthIncreaseNum < 0
                        ? "data-red"
                        : "data-green",
                  },
                  [
                    _c("span", {
                      staticClass: "arrow south-east el-icon-bottom-right",
                    }),
                    _c("span", {
                      staticClass: "arrow north-east el-icon-top-right",
                    }),
                    _c("label", [_vm._v("较比上月")]),
                    _vm.resetDateObj.prevMonthIncreaseNum >= 0
                      ? _c("span", [_vm._v("+")])
                      : _vm._e(),
                    _vm._v(_vm._s(_vm.resetDateObj.prevMonthIncrease) + "% "),
                  ]
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }